import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { signout, isAuthenticated } from '../auth';

const isActive = (history, path) => {
    if (history.location.pathname === path) {
        return { color: '#ff9900', borderColor: '#ff9900' }
    } else {
        return { color: '#ffffff', opacity: 1 }
    }
}

const hideNavigation = () => {
    //alert('hide')
    if(document.getElementById('reactNavBar')){
        document.getElementById('reactNavBar').className = 'navbar-collapse collapse';
    }
    //lMenu.attr('class','collapse navbar-collapse');
    //console.log(lMenu)
    //navbar-toggler collapsed
}

const Menu = ({ history }) => (
    <div className="fixed-top">
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
            <Link id="home_link" className="nav-link" style={isActive(history, "/")} to="/">Home</Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#reactNavBar" aria-controls="reactNavBar" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon" style={{opacity: 1, color: "#ffffff"}}></span>
            </button>
            <div onClick={hideNavigation()} className="navbar-collapse collapse" id="reactNavBar">
                <div className="navbar-nav">
                    <Link className="nav-link" style={isActive(history, "/users")} to="/users">Users</Link>
                    <Link className="nav-link" style={isActive(history, "/post/create")} to="/post/create">Create Post</Link>
                    {!isAuthenticated() && (
                        <>
                            <Link id="sign_in_link" className="nav-link" style={isActive(history, "/signin")} to="/signin">Sign In</Link>
                            <Link className="nav-link" style={isActive(history, "/signup")} to="/signup">Sign Up</Link>
                        </>
                    )}
                    {isAuthenticated() && (
                        <>
                            <Link className="nav-link" style={isActive(history, "/user/findpeople")} to="/user/findpeople">Find Users</Link>
                            <Link className="nav-link" style={isActive(history, `/user/${isAuthenticated().user._id}`)} to={`/user/${isAuthenticated().user._id}`}>{`${isAuthenticated().user.name}'s Profile`}</Link>
                            <a href="#signout" id="sign_out_link" className="btn btn-outline-warning btn-sm" onClick={() => signout(() => history.push("/"))}>Sign Out</a>
                        </>
                    )}
                    {
                        
                        
                    }
                </div>
            </div>
        </nav>
    </div>
)


export default withRouter(Menu);